import { trim, filter } from '../../../shared/modules/common';

export default function search(list, pattern) {
    function isExactMatch(element) {
        var regexp = new RegExp(trim.call(pattern), 'i');
        return regexp.test(element);
    }

    return filter.call(list, isExactMatch);
};



//////////////////
// WEBPACK FOOTER
// ./widgets/Dropdown/js/dropdownSearch.js
// module id = 87
// module chunks = main